import React from 'react'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useTranslation } from 'react-i18next'
import { createStyles, makeStyles, Radio } from '@material-ui/core'
import { PayoutPractitioner } from '../../../api/salaryCalculation'

type PractitionersFilterProps = {
  onChange: (value: PayoutPractitioner) => void
  value?: PayoutPractitioner
  practitioners?: PayoutPractitioner[]
}

const useStyles = makeStyles(() =>
  createStyles({
    option: {
      paddingTop: 8,
      paddingBottom: 8,
      '&:hover': {
        backgroundColor: '#EDF8F7',
        cursor: 'pointer',
      },
      '&[aria-selected=true]': {
        backgroundColor: '#CAEDE7',
        '&:hover': {
          backgroundColor: '#A8DDD6',
        },
      },
    },
    listbox: {
      padding: 0,
      maxHeight: 350,
      overflowY: 'scroll',
    },
  })
)

const PractitionersFilter = ({ onChange, value, practitioners }: PractitionersFilterProps) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const getOptionLabel = (option: PayoutPractitioner) => `${option.name} | ${option.clinic.name}`

  return (
    <Autocomplete
      value={value}
      options={practitioners ?? []}
      classes={classes}
      getOptionLabel={getOptionLabel}
      style={{ width: 450 }}
      renderOption={(option) => {
        const isSelected = value?.referenceId === option.referenceId

        return (
          <>
            <Radio checked={isSelected} value={option.referenceId} color="primary" />
            <span>{getOptionLabel(option)}</span>
          </>
        )
      }}
      renderInput={(params) => (
        <TextField {...params} label={t('compensation_table_practitioners_filter_label')} variant="outlined" />
      )}
      onChange={(e, value) => onChange(value as PayoutPractitioner)}
      loading={!practitioners}
    />
  )
}

export default PractitionersFilter
